import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {IBankDruo} from "../interfaces/iexpress-league";

/**
 * ✅ Valida el formato general de una CLABE:
 * - Solo permite dígitos (0–9)
 * - Máximo 18 caracteres
 * - Opcionalmente puedes exigir longitud exacta de 18
 */
export function clabeFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = (control.value ?? '') as string;

    // Si está vacío, no marcamos error (usar Validators.required aparte)
    if (!rawValue) return null;

    // Quitar espacios o caracteres no numéricos
    const onlyDigits = rawValue.replace(/\D+/g, '');

    // Verifica si el usuario escribió letras o símbolos
    if (onlyDigits !== rawValue) {
      return { clabeInvalidChars: 'La CLABE solo debe contener números.' };
    }

    if (rawValue.length > 0 && rawValue.length < 3) {
      return { clabeTooShortForBank: 'Escribe al menos 3 dígitos para validar el banco.' };
    }
    if (rawValue.length > 18) {
      return { clabeTooLong: 'La CLABE no debe exceder los 18 dígitos.' };
    }

    return null;
  };
}

export function clabeBankSupportedValidator(banks: IBankDruo[]): ValidatorFn {
  const bankMap = new Map(banks.map(b => [b.digito, b]));
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = (control.value ?? '') as string;
    if (!rawValue || rawValue.length < 3) return null;

    const prefix = rawValue.substring(0, 3);
    if (!bankMap.has(prefix)) {
      return { clabeBankUnsupported: `El banco con prefijo "${prefix}" no está soportado por DRUO.` };
    }
    return null;
  };
}
